import { cn } from '@shared/lib/cn';

export interface AvatarProps {
  name: string;
  className?: string;
}

function initialsOf(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}

/** Avatar utilisateur aux initiales, sur fond d'accent. */
export function Avatar({ name, className }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex size-8 items-center justify-center rounded-full bg-slate-700 text-xs font-semibold text-slate-100',
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
